export const getReport = `
    query getReport(
        $reportId: String!
        $sortModel: [SortModelInput]
        $filterModel: AWSJSON
        $paginationModel: PaginationModelInput
        $term: String
        $subProgramId: String
        $export: Boolean
    ) {
        getReport(
            reportId: $reportId
            sortModel: $sortModel
            filterModel: $filterModel
            paginationModel: $paginationModel
            term: $term
            subProgramId: $subProgramId
            export: $export
        ) {
            columns
            items
            totalCount
            reasons
            signedUrl
        }
    }
`;


export const approveRecommendations = `
    mutation approveRecommendations($input: ApproveRecommendationInput!) {
        approveRecommendations(input: $input) {
            status
            executionId
        }
    }`

    // New mutation to start the Publish Applications state machine
export const publishApplications = `
    mutation publishApplications($input: PublishApplicationsInput!) {
        publishApplications(input: $input) {
            status
            executionId
            message
        }
    }
`;

export const submitStudentRequestProgramChangeWithdraw = `
    mutation submitStudentRequestProgramChangeWithdraw($input: [ApplicationKeyInput!]!) {
        submitStudentRequestProgramChangeWithdraw: studentRequestProcessed(input: $input) {
            status
            executionId
            message
        }
    }
`;

export const approveDenyRequests = `
    mutation approveDenyRequests($applicantEmployeeIds: [String!], $programId: String!, $term: String!, $requestType: String!, $isApproved: Boolean!) {
        approveDenyRequests(applicantEmployeeIds: $applicantEmployeeIds, programId: $programId, term: $term, requestType: $requestType, isApproved: $isApproved) {
            status
        }
    }
`;